import { L10n } from '../L10n/L10n';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { AbstractContentAction } from '../../commonInfra/contentActions/AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { Messages } from '../../codegen/Localize';

export class RunFlowTasksAction extends AbstractContentAction<RunFlowTaskInfo> {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    ConfirmActionDialog: ConfirmActionDialog,
  ) {
    super(ConfirmActionDialog);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    const taskCount = runFlowTaskInfos.size();
    if (taskCount === 1) {
      const task = runFlowTaskInfos.first();
      dialogConfig.bodyText = this.$translate.instant('runFlowTaskRunPrompt', {
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
      dialogConfig.bodyText = this.$translate.instant('runFlowTasksRunPrompt', {
        ITEM_COUNT: taskCount
      }, L10n.Interpolations.Count);
    }
    dialogConfig.title = this.$translate.instant('runNow');
    dialogConfig.actionName = this.$translate.instant('runNowConfirmButton', {
      ITEM_COUNT: taskCount
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => RunFlowTasks.run(runFlowTaskInfos.keys());
  }

  notificationTranslationFns() {
    return {
      successMsg: simpleActionSuccessMsg(Messages.runFlowTasksRunSuccess),
      errorMsg: simpleActionErrorMsg(Messages.runFlowTasksRunError),
    };
  }

}

Module.instance().service('RunFlowTasksAction', RunFlowTasksAction);
